<template>
    <div 
      class="loading-mask" 
      v-if="visible"
      :class="{ 'loading-fullscreen': fullscreen }"
    >
      <div class="loading-spinner">
        <!-- 加载动画 -->
        <div class="spinner"></div>
        <!-- 加载文本 -->
        <div class="loading-text" v-if="text">{{ text }}</div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Loading',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        text: '',
        fullscreen: true
      }
    },
    methods: {
      // 显示loading
      show(options = {}) {
        // 处理配置
        if (typeof options === 'string') {
          this.text = options
        } else {
          this.text = options.text || ''
          this.fullscreen = options.fullscreen !== false
        }
      },
      // 隐藏loading
      hide() {
        this.text = ''
      }
    }
  }
  </script>
  
  <style scoped>
  .loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s;
  }
  
  .loading-spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  /* 加载动画 */
  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  /* 加载文本 */
  .loading-text {
    margin-top: 16px;
    color: #333;
    font-size: 14px;
  }
  
  /* 旋转动画 */
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  </style>
  